export default __webpack_public_path__ + "static/media/logo-dental-login.3a17c4d5.jpg";